import { Button, Label, makeStyles, Link } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { ReactComponent as AdvancedLogo } from './advancedLogo.svg';
import { app } from "@microsoft/teams-js";
import LoggingService from "../services/loggingService";
import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { MessageType } from "../enums/messageType";

const useStyles = makeStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '90vh'
    }
});

export default function LoginRedirect(props:any) {
    const navigate = useNavigate();
    const classes = useStyles();
    const auth = useAuth();
    
    useEffect(() => {
        app.initialize().then(() => {
           app.getContext().then(async (context) => {
              sessionStorage.setItem('hostClientType', context.app.host.clientType);
              LoggingService.log(LoggingService.isLoggingEnabled() ? `LoginRedirect - Context loaded` : '', MessageType.Info);
    
              var code = context.page.subPageId;
              if (code != null && code.length > 0){
                LoggingService.log(LoggingService.isLoggingEnabled() ? `LoginRedirect - Found code in context` : '', MessageType.Info);
                context.page.subPageId = '';
                auth.getToken(code).then((result) => {
                  if (result){
                    LoggingService.log(LoggingService.isLoggingEnabled() ? `LoginRedirect - Navigating to tab.` : '', MessageType.Info);
                    navigate("/tab");
                  }
                });
              }
           });
        });
      }, []);

    // Redirects to the login component
    async function redirect() {
        navigate("/externalLoginIdp");
    }
    
    return (
        <div className={classes.container}>
            <AdvancedLogo style={{ width: '20rem', height: 'auto' }} />
            {props.isTokenExpired === 'true' ? (
                <Label style={{ padding: '3rem 0rem 1rem 0rem' }}>Your session has expired. Please login to the application again.</Label>
            ):(
                <div style={{ padding: '3rem 0rem 0.5rem 0rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Label style={{ padding: '0rem 1rem 0.5rem 1rem' }}>A valid OneAdvanced Time Capture (Carpe Diem) account is required to use this app.</Label>
                    <Label style={{ padding: '0rem 1rem 0.5rem 1rem' }}>Please visit <Link href="https://www.oneadvanced.com/products/time-capture" target="blank">OneAdvanced Time Capture</Link> for more information.</Label>
                    <Label style={{ padding: '2rem 1rem 0.5rem 1rem' }}>Please log into your account to start using the app.</Label>
                </div>
            )}
            <Button appearance="primary" onClick={() => redirect()} >Login</Button>
      </div>
        
    )
}